export default "__VITE_ASSET__kgt9Um$4__"